export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-09.4ec6e36f.jpg";